import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Teamimg1 from "../images/Frame 386.png";
import clara from "../images/Frame 387.png";
import john from "../images/Frame 388.png";
import preethi from "../images/Frame 390.png";
import gladwin from "../images/Frame 392.png";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../../config";

function TeamUpdate() {
  const [eom, setEOM] = useState(null);
  const [starofYear, setStarofYear] = useState(null);
  const [empofDept, setEmpofDept] = useState(null);
  const [loqData, setLOQData] = useState(null);
  const [toq, setTOQ] = useState(null);
  const [teamofQuarterNames, setTeamofQuarterNames] = useState([]);

  useEffect(() => {
    const fetchEOMData = async () => {
      try {
        const did = localStorage.getItem("departmentid");
        const response = await axios.get(`${baseURL}/geteom?did=` + did);
        const data = response.data;
        let eom = data.employeeofmonth;
        setEOM(eom);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEOMData();
  }, []);
  useEffect(() => {
    const fetchEOMData = async () => {
      try {
        const did = localStorage.getItem("departmentid");
        const response = await axios.get(`${baseURL}/getstarofyear?did=` + did);
        const data = response.data;
        let soy = data.starofyear;
        setStarofYear(soy);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEOMData();
  }, []);
  useEffect(() => {
    const fetchEOMData = async () => {
      try {
        const did = localStorage.getItem("departmentid");
        const response = await axios.get(`${baseURL}/getempofdept?did=` + did);
        const data = response.data;
        let soy = data.empofdept;
        setEmpofDept(soy);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchEOMData();
  }, []);

  useEffect(() => {
    const fetchLOQData = async () => {
      try {
        const did = localStorage.getItem("departmentid");
        const response = await axios.get(`${baseURL}/getLeaderofQtrapproved`);
        const data = response.data;
        let loqdata = data.leaderofqtr[0];
        setLOQData(loqdata);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchLOQData();
  }, []);

  useEffect(() => {
    const fetchTOQData = async () => {
      try {
        const did = localStorage.getItem("departmentid");
        const response = await axios.get(`${baseURL}/getteamofqtrapproved`);
        const data = response.data;
        let toqdata = data.teamofquarter[0];
        const namesArray = toqdata.employee_names
          .split(",")
          .map((name) => name.trim());
        setTeamofQuarterNames(namesArray);
        setTOQ(toqdata);
      } catch (err) {
        console.error("Error fetching team members:", err);
      }
    };
    fetchTOQData();
  }, []);
  return (
    <div className="col-lg-12 pb-1 m-4 mr-1 ">
      <div className="row m-2 ">
        <Card className="m-1 Regular shadow p-1" style={{ width: "23%" }}>
          <Card.Img
            className=" w-50 m-auto pt-3"
            variant="top center"
            src={Teamimg1}
          />
          <Card.Body className="p-1">
            {/* <Card.Title className='text-center'><h5>Venkat</h5></Card.Title> */}
            <Card.Text className="text-center">
              <p className="card_des">Leader of the Quarter</p>
              {loqData ? (
                <h6>
                  {loqData.employee_firstname} {loqData.employee_lastname}
                </h6>
              ) : (
                <h6>To be nominated</h6>
              )}
              {/* <p className='card_des'><a href='#' className='text-black'>View Details</a></p> */}
              <p className="skill_card_status">
                {loqData && loqData.month_year}
              </p>
            </Card.Text>
          </Card.Body>
        </Card>

        <>
          {eom &&
            eom.map((eomdata, index) => (
              <Card
                key={index}
                className="m-1 Regular shadow p-1"
                style={{ width: "23%" }}
              >
                <Card.Img
                  className="w-50 m-auto pt-3"
                  variant="top center"
                  src={
                    eomdata?.photo
                      ? `${baseURL}/getcertifcate?filename=` + eomdata?.photo
                      : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                  }
                />

                <Card.Body className="p-1">
                  {/* <Card.Title className='text-center'>   <h5>{eom.employee_firstname}</h5></Card.Title> */}
                  <Card.Text className="text-center">
                    <p className="card_des">Employee of the Month</p>
                    <p className="skill_card_status">
                      {eomdata ? (
                        <h6>
                          {eomdata.employee_firstname}{" "}
                          {eomdata.employee_lastname}
                        </h6>
                      ) : (
                        <h6>To be nominated</h6>
                      )}
                    </p>
                    <p className="skill_card_status">
                      {eomdata && eomdata.month_year}
                    </p>
                    {/* <p className='card_des'><a href='#' className='text-black'>View Details</a></p> */}
                  </Card.Text>
                </Card.Body>
              </Card>
            ))}
        </>

        {starofYear &&
          starofYear.map((starofYear, index) => (
            <Card className="m-1 Regular shadow p-1" style={{ width: "23%" }}>
              <Card.Img
                className=" w-50 m-auto pt-3"
                variant="top center"
                src={
                  starofYear?.photo
                    ? `${baseURL}/getcertifcate?filename=` + starofYear?.photo
                    : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                }
              />
              <Card.Body className="p-1">
                {/* <Card.Title className='text-center'> <h5>Clara</h5></Card.Title> */}
                <Card.Text className="text-center">
                  <p className="card_des">Star of the Year</p>
                  <p className="skill_card_status">
                    {starofYear ? (
                      <h6>
                        {starofYear.employee_firstname}{" "}
                        {starofYear.employee_lastname}
                      </h6>
                    ) : (
                      <h6>To be nominated</h6>
                    )}
                  </p>
                  <p className="skill_card_status">
                    {starofYear && starofYear.month_year}
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          ))}

        {empofDept &&
          empofDept.map((empofDept, index) => (
            <Card className="m-1 Regular shadow p-1" style={{ width: "23%" }}>
              <Card.Img
                className=" w-50 m-auto pt-3"
                variant="top center"
                src={john}
              />
              <Card.Body className="p-1">
                {/* <Card.Title className='text-center'>   <h5>Jhon</h5></Card.Title> */}
                <Card.Text className="text-center">
                  <p className="card_des">Employee of the Department</p>
                  <p className="skill_card_status"></p>

                  {empofDept ? (
                    <h6>
                      {empofDept.employee_firstname}{" "}
                      {empofDept.employee_lastname}
                    </h6>
                  ) : (
                    <h6>To be nominated</h6>
                  )}
                  <p className="skill_card_status">
                    {empofDept && empofDept.month_year}
                  </p>
                </Card.Text>
              </Card.Body>
            </Card>
          ))}
      </div>

      <Card className="m-3 Regular shadow p-1 " style={{ width: "39%" }}>
        <Card.Img
          className=" w-50 m-auto pt-3"
          variant="top center"
          src={null}
        />
        <Card.Body className="p-1">
          {/* <Card.Title className='text-center'><h5>Venkat</h5></Card.Title> */}
          <Card.Text className="">
            <p className="card_des  text-center fw-bold">Team of the Quarter</p>
            {toq ? (
              <h6 style={{ fontSize: "12px" }}>
                <ul style={{ listStyleType: "none", paddingLeft: "1rem" }}>
                  {teamofQuarterNames.map((name, index) => (
                    <li
                      className="p-2"
                      key={index}
                      style={{ paddingLeft: "1em", textIndent: "-1em" }}
                    >
                      <span>
                        <img
                          alt="hh"
                          width={"25px"}
                          src={
                            toq?.photo
                              ? `${baseURL}/getcertifcate?filename=` +
                                toq?.photo
                              : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAADlAAAA5QGP5Zs8AAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAelQTFRF////JG2SQICAJ05iM1VVNXWAM3CFKUtRM3GCJkdRNHCBJkNNJ0BIMnCAM3GAMnCAJDtBNHKAM3GAIzU5IzY7M3GAM3GAKk1WIi8yM3GAISwwM3GAM3GAICgrHyYoHiIjIiUoFBQUFRUUFhUVFhYWFxYWGRkYHBoYHR0eHR4fHh4fHiEiHiEjHx8gIi8zIjE1IjI2Ix4bIyMlIzU6JCAdJCIgJDY8JyIfJ0VNKEZNKSksKSktKTg5LCciLSsnLychL2JvL2VyMGNvMGVzMGZzMGl2MWp4MWt5MWx6Mm17Mm99MyojMzM5M2BpM3B/M3GANXKAN3KAOGx4OjUvO3SAPXSAPjw2Pj45PmVqPz9HP2ZsQF9iQ0VMQ0VNRUVNRUVORkQ9RkZPR1BMSEhRSUlTSkpUU0EzVldfV1dfWU1AXEc3XE9CXn+AXoCAX2l1YGl2Y4KBZk48a1I/b4J+co2iepOVe3uBe5OVgI+Xh46BjGlPjrDHkm5SmXJVnr/Tn7/TocDUo73Npr/PqcPUqq61r4JgsINhsbK1tMjVxZ98xaOCyKF+0aaB1NbY1qmC2ZRk2qB126J23KJ24KyC4qN55Kh65Onu5Oru5qZ75rWV6qh37Kx+7eLc7qx8769/8bGB8vn+87KB9LOCwa3cagAAACF0Uk5TAAcIDQ8YGSwtL0lQfISXmL/ByNXV2uPu7/Lz8/X5/P7+cDzfRAAAAfxJREFUGBllwYk/FFEcAPDfDrsYZtYsu6wZx+t8uSrddEh3aX8Ula5NTCelSESlKBKr0uEs3l/azHvP7O7H9wtJPjVohE0zbARVH2wW0KPoieoBSKdoFqaxNAVS+EMonb+AUsgPnuwIclfuHSJbjl27jFwkGyR/BLkb+wm3/SZyET9wSgiFq0Q6cAa5kAIuDYVbRNh5iRxFQQNHwELhPnGdePNrlGy7iJwVAAAdpeuEbH3w6R9jnwk5iYIO4IuidJy8/MZcf/fuQCnqAxWltsdPmPTiaRtKKgRR6vs6yqS3X/pQCoKBUm/iO5N+JHpRMiCMUmuCeRKtKIXBxA0980ya78ENJpjoGWZsfXV1nbFh9JgQRk/LNFuam1ti0y3oCYOBSe0zzDHTjkkGBDFF/8Ly8kI/pgiCiile/3S8whQq+KIoxZqG1lYWF1fWhppiKEV9ADq6Th3eXV1jT/weG/szYddU7zlyGl06AAQsxLP7qCveNfvh42xXnDp2HTyHaAXAoWGslnId9uTU1KTdQbnaGGrgUkKNVKjvHBwfH+ysp0JjSAHOX0SFuu6H794/6q6jQpEfpNwyKjTbIyN2MxXKcsGTVUK5yrsDA/FKypVkQYrM/Crqanj2vIG6qvIzIV1OQTl13L5DHeUFObBZRl5hcWlFRWlxYV4GeP4Dm5L5s3KTpvYAAAAASUVORK5CYII="
                          }
                        />
                      </span>{" "}
                      {name}
                    </li>
                  ))}
                </ul>
              </h6>
            ) : (
              <h6>To be nominated</h6>
            )}
            {/* <p className='card_des'><a href='#' className='text-black'>View Details</a></p> */}
            <p className="text-center skill_card_status">
              {toq && toq.month_year}
            </p>
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
}

export default TeamUpdate;
